import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const newPasswordPageK = {
  createPassword: "new_password_page.createPassword",
  newPasswordCreated: "new_password_page.newPasswordCreated",
  newPasswordCreatedHint: "new_password_page.newPasswordCreatedHint",
};

export const useNewPasswordPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      createPassword: t(newPasswordPageK.createPassword),
      newPasswordCreated: t(newPasswordPageK.newPasswordCreated),
      newPasswordCreatedHint: t(newPasswordPageK.newPasswordCreatedHint),
    }),
    [i18n.language]
  );
};